import useRecommendations from '~/hooks/useRecommendations';

import RecommendationsForm from '../components/RecommendationsForm';

export default function Recommendations() {
  const { boostedRecommendations, recommendations, hasNextPage, loadNextPage, isLoading } = useRecommendations();

  return (
    <RecommendationsForm
      recommendations={recommendations}
      boostedRecommendations={boostedRecommendations}
      hasNextPage={hasNextPage}
      loadNextPage={loadNextPage}
      isLoading={isLoading}
    />
  );
}
